<template>
  <footer class="site-footer" v-if="!isAdminRoute">
    <!-- 底部区域 -->
    <div class="foot">
      <div class="foot-context">
        <!-- <span class="foot-text text1">关于我们&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;常见问题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务条款&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;隐私政策</span> -->
        <span class="foot-text text2">Copyright&nbsp;©2025简单画素材网&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;<a href="http://beian.miit.gov.cn/" target="_blank" style="color: inherit; text-decoration: none;">粤ICP备2023116266号-13</a></span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const isAdminRoute = computed(() => route.path.startsWith('/admin'))
const footerLinks = ref([])

const backendUrl = ref(import.meta.env.VITE_JAVA_API_URL)


const fetchFooterLinks = async () => {
  try {
    const response = await fetch(`${backendUrl.value}/system/footer/getFooter`)
    if (response.ok) {
      const data = await response.json()
      footerLinks.value = data.data
    }
  } catch (error) {
    console.error('获取页脚链接失败:', error)
  }
}

// onMounted(fetchFooterLinks)
</script>

<style scoped>
.site-footer {
  width: 100%;
  padding: 20px 0;
  background: linear-gradient(135deg, #FAF5FF 0%, #F4F6FF 100%);
  text-align: center;
  margin-top: auto; /* 确保footer在内容不足时也在底部 */
  border-top: 1px solid #eee;
}

.foot {
  max-width: 1200px;
  margin: 0 auto;
}

.foot-context {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.foot-text {
  font-size: 14px;
  line-height: 1.5;
}

.foot-text.text1 {
  color: #333;
  letter-spacing: 0.5px;
}

.foot-text.text2 {
  color: #999;
  letter-spacing: 0.3px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .site-footer {
    padding: 15px 0;
  }
  
  .foot-context {
    padding: 0 15px;
  }
  
  .foot-text {
    font-size: 12px;
  }
  
  .foot-text.text1 {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
</style>